//import { MenuOption } from "../menu-engine/MenuOption";
import {
  setBattleValue,
  setMatchmakingValue
} from "../redux-actions/battle-actions";
import { setGlobalValue } from "../redux-actions/global-actions.js";

export function goToQuickBattle() {
  //Set to single player mode and change to Battle arena
  setBattleValue({ isMultiplayerMode: false });
  setGlobalValue({ gameArea: "arena" });
}

export function goToFullTeamMultiplayerBattle() {
  //Set to multiplayer mode and change to Battle arena
  setMatchmakingValue({ createRoomType: "fullteam" });
  setBattleValue({ isMultiplayerMode: true });
  setGlobalValue({ gameArea: "arena" });
}

export function goToOpenBattle() {
  //Set to multiplayer mode and change to Battle arena
  setMatchmakingValue({ createRoomType: "open" });
  setBattleValue({ isMultiplayerMode: true });
  setGlobalValue({ gameArea: "arena" });
}

export function goToRecordScreen() {
  //Transition To Record Screen
  setGlobalValue({ gameArea: "b5-records-screen" });
}

export function goToHomeScreen() {
  //Transition To Home Screen
  setGlobalValue({ gameArea: "b5-home-screen" });
}

export function goToArenaFromInvite() {
  //Transition To Arena
  //unopinionated of which roomtype, because is used when you've been invited to a specific room.
  setGlobalValue({ gameArea: "arena" });
}

// export function getHomeMenuOptions() {
//   return {
//     views: {
//       homeView: {
//         viewBag: {},
//         getMenuOptions() {
//           return {
//             quickBattle: MenuOption({
//               label: "Quick Battle",
//               handleOptionEnter() {
//                 goToQuickBattle();
//               }
//             }),
//             onlineTeamBattle: MenuOption({
//               label: "Multiplayer Crew Battle",
//               handleOptionEnter() {
//                 goToFullTeamMultiplayerBattle();
//               }
//             }),
//             onlineOpenBattle: MenuOption({
//               label: "Multiplayer Open Battle",
//               handleOptionEnter() {
//                 goToOpenBattle();
//               }
//             }),
//             stayUpdated: MenuOption({
//               label: "Stay Updated",
//               handleOptionEnter(menuModel) {
//                 console.log("handle this one - Stay Updated");
//
//                 //Lock the menu
//                 menuModel.lock();
//
//                 //Open the modal
//                 setGlobalValue({ isHomeEmailModalOpen: true });
//               }
//             })
//           };
//         },
//         getMenuOptionsLayout() {
//           return [
//             ["quickBattle"],
//             ["onlineTeamBattle"],
//             ["onlineOpenBattle"],
//             ["stayUpdated"]
//           ]; //the only option
//         }
//       }
//     }
//   };
// }



// WEBPACK FOOTER //
// ./src/b5-home/get-home-menu-options.js